import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'//引入路由文件
import $ from 'jquery'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/main.css'
import '../static/UEditor/themes/default/css/umeditor.min.css'
import '../static/UEditor/dialogs/image/image.css'
import Axios from 'axios'
// import BaiduMap from 'vue-baidu-map'//百度地图

Vue.use(ElementUI);

Vue.config.productionTip = false
const localObj = window.location;
const rootDomain = localObj.protocol + "//" + localObj.host + "/";
let urlherf = document.documentElement.clientWidth;
window.addEventListener("resize", function () {
  urlherf = document.body.offsetWidth;
  if (urlherf > 900) {
    // if (rootDomain) {
    // }
  }
  //   console.log(urlherf);
});
router.beforeEach((to, from,next) => {
  console.log(to, from, urlherf, "to,from");
  if(to.path == "/hlj"){
    next()  
  }else if(to.path == "/Geographical"){
    next()
  }else if(to.path == "/fcp"){
    next()
  }else if(to.path == "/riskManagementDetails"){
    next()
  }else{
    if (urlherf < 900) {
      if (to.path == "/productSeachDetails") {
        window.location.href =
        rootDomain+"pageh5/" +
          "productSearchdetails?id=" +
          to.query.id;
      } else if(to.path == "/psCommunicationdetails"){
        window.location.href =
        rootDomain+"pageh5/" +
          "exchangeDetails?id=" +
          to.query.id;
      }else if(to.path == "/newsDetails"){
        window.location.href =
        rootDomain+"pageh5/" +
          "exchangeDetails?id=" +
          to.query.id+'&&columnName=新闻详情';
      } else {
        window.location.href = rootDomain+"pageh5/";
      }
    }else {
      next()
    }
  }
});
import '../static/js/jquery.min.js'
import '../static/js/OstPaths.js'
import '../static/js/DataStore.min.js'
import { getCookie } from '../static/js/cookie.js'
import { setCookie } from '../static/js/cookie.js'
import { formatFn } from '../static/js/date.js'
import * as tool from '@/assets/js/tool.js'
import * as cookies from '../static/js/cookie.js'
import store from './store/index.js'
// import VueAMap from "vue-amap";


// VueAMap.initAMapApiLoader({
//   key: "e3ecea2ee9b0cd018c42744d1567e372",
//   plugin: [
//     "AMap.Size",
//     "AMap.Pixel",
//     "AMap.MassMarks ",
//     "AMap.MarkerClusterer",
//     "AMap.Autocomplete",
//     "AMap.PlaceSearch",
//     "AMap.DistrictSearch",
//     "AMap.Scale",
//     "AMap.OverView",
//     "AMap.ToolBar",
//     "AMap.MapType",
//     "AMap.Geolocation",
//     "AMap.Geocoder",
//     "AMap.AMapManager",
//     "AMap.Marker",
//     'AMap.Map'
//   ],
//   // 默认高德 sdk 版本为 1.4.4
//   v: "1.4.15",
//   uiVersion: "1.0",
// });
// Vue.use(VueAMap);
// 自定义指令 容器外触发
import '../static/js/directive'
import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll); 
// Vue.use(AMapLoader);
window._AMapSecurityConfig = {
  securityJsCode:'b45032015936e65ac00e672091e043d3',
}

// Vue.use(BaiduMap, {
//   ak: 'qvEBjYRcHmpZCDXR849MnC73QGstenOE'
// })
import 'swiper/swiper-bundle.css'

Vue.prototype.getCookie = getCookie;
Vue.prototype.setCookie = setCookie;

Vue.prototype.formatFn = formatFn;

// import echarts from 'echarts' //引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts //引入组件

Vue.prototype.tool = tool;
Vue.prototype.getDictType = tool.getDictType;
Vue.prototype.getDictLabel = tool.getDictLabel;
Vue.prototype.cookies = cookies;
Vue.prototype.Axios = Axios;
Vue.prototype.Axios.defaults.withCredentials = true;
Vue.prototype.Axios.defaults.headers = {
  'Content-Type': 'application/json'

};

function formatDict (type, val) {//数据字典过滤器
  var val = $(window).DataStore().getDictLabel(type, val);
  return val;
};
//数据字典过滤器
Vue.filter('formatDict', formatDict);
Vue.filter('formatDate', tool.formatDate);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  watch:{
    '$route':function(to,from) {
    var toPath=to.path;
    this.toPath=toPath;
    if(toPath.indexOf("/suyh5")==-1){
      /*全局配置页面title*/
      document.title = to.name + '-全国农产品质量安全特征库门户';
    }else{
      document.title = to.name;
    }
 
    //添加一个响应拦截器
    
    Axios.interceptors.response.use(function(res){
      //在这里对返回的数据进行处理
      var data = res.data;
      return res;
    },function(err){
      var _this = this 
      var isErrInfo = arguments[0].response.data.error_description.indexOf('Access token expired');//权限是否过期
      var isErrInfo1 = arguments[0].response.data.error_description.indexOf('An Authentication object was not found in the SecurityContext');//没有token串
      if(isErrInfo>=0 || isErrInfo1>=0) {
        setCookie('userInfodoor','');
      }
      return Promise.reject(err);
    });
    return false;
    }
},


watch:{
  '$route':function(){
    var locationUrl = window.location.pathname;
    if(locationUrl == '/homePage'){
      this.$store.commit('locationFlagchange',true)
      this.$store.commit('homefankuiflag',false)
    }else{
      this.$store.commit('homefankuiflag',true)
      this.$store.commit('locationFlagchange',false)
    }

    if(locationUrl == '/productSeach'){
      this.$store.commit('seachflagchange',false)
      this.$store.commit('fankuiflag',false)
    }else{
      this.$store.commit('seachflagchange',true)
      this.$store.commit('fankuiflag',true)
    }


    if(getCookie('userInfodoor')) {//添加公用 Authorization
      Axios.defaults.headers.Authorization = JSON.parse(getCookie('userInfodoor')).tokenType+ ' ' + JSON.parse(getCookie('userInfodoor')).accessToken;
    } else {
      
    };
  return false;
  }
},

  mounted () {

    
  },
})


// WEBPACK FOOTER //
// ./src/main.js